export type BannerAction<T> = {
    type: 'create' | 'edit' | 'view' | 'delete' | null;
    banner: T | null;
};

export const defaultBannerAction: BannerAction<never> = {
    type: null,
    banner: null,
};
